import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/hotels-and-lodging__hero.jpg'
import img01 from '../../images/hotels-lodging-1.jpg'
import img02 from '../../images/hotels-lodging-2.jpg'
import img03 from '../../images/hotels-lodging-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Hotels & Lodging | What We Offer"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Hotels & Lodging</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__images c-golden__short min-laptop">
          <img src={img01} alt="" style={{ width: '50%', height: '100%' }} />
          <img src={img02} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img03} alt="" style={{ width: '50%', height: '50%' }} />
        </div>
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/what-we-offer">What We Offer</Link>
            </li>
            <li>
              <Link
                to="/what-we-offer/hotels-and-lodging"
                activeClassName="is-active"
              >
                Hotels & Lodging
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">
                We’re more than a Bedbank
              </h1>
              <p className="t-p t-p-light mt30">
              Offering preferred rates at over 25,000 properties, we are North America’s 
              leading accommodation and service provider. Our team of dedicated and experienced buyers 
              negotiate unbeatable exclusive rates in not only North America’s most popular destinations, 
              but also in areas where availability is scarce, like our National Parks. ATI delivers more 
              lodging availability inside America’s National Parks than any other operator in the world. 
              When your destination includes our majestic National Parks, only we can get you there. We 
              also offer preferred rates at a broad array of specialty lodgings like short-term stay 
              apartments, vacation rentals, house boats, ranches, luxury camping accommodations, and more… 
              We’re more than a Bedbank because we’re dedicated to providing our clients with not just the 
              lowest rates, but the support of a full-service tour operator.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/what-we-offer/hotels-and-lodging.js